<template>
    <b-modal id="importar-atracoes-artisticas-modal" size="md" centered header-bg-variant="secondary"
        header-text-variant="light" title="Importar atrações artísticas de planilha" @hidden="$emit('fecharModal')">
        <b-row>
            <b-col cols="12">
                <b-form-group id="arquivo-input-group" label="" label-for="input-arquivo" label-cols="auto">
                    <b-form-file v-model="arquivo" placeholder="Escolha o arquivo" drop-placeholder="Solte o arquivo aqui"
                        class="" browse-text="Escolher" accept=".xlsx" :disabled="showLoading"></b-form-file>
                </b-form-group>
            </b-col>
        </b-row>
        <template v-slot:modal-footer="">
            <b-spinner v-if="showLoading"></b-spinner>
            <btn-download botao :fazerDownload="downloadModelo" :texto="'Baixar o modelo'" :disabled="showLoading" />
            <b-button size="sm" variant="success" @click="enviarArquivo" :disabled="showLoading">
                <font-awesome-icon icon="cloud-upload" />
                Confirmar
            </b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import programacaoService from '@/services/eventos/programacaoService'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import BtnDownload from '@/components/shared/btn-download.vue'

const CompProps = Vue.extend({
    name: 'ModalImportarAtracoesArtisticas',
    components: { BtnDownload },
    props: {
        idProgramacao: {
            type: Number,
            required: true
        },
        modo: {
            type: String,
            validator(value: string) {
                return ['item', 'lote'].includes(value)
            },
            default: 'item'
        }
    }
})

@Component
export default class ModalImportarAtracoesArtisticas extends mixins(UtilsTS, CompProps) {
    arquivo: File | null = null
    showLoading = false

    async mounted() {
        this.$bvModal.show("importar-atracoes-artisticas-modal");
    }

    async downloadModelo() {
        const responseBlob = await programacaoService.baixarModeloImportacaoAtracoes(this.modo === 'lote' ? 'itensLote' : 'itens')
        this.download(`modelo-importacao-atracoes-artisticas.xlsx`, responseBlob)
    }
    async enviarArquivo() {
        this.showLoading = true
        try {
            if(this.arquivo === null) {
                this.$toast.error("O arquivo deve ser informado.")
                return;
            }

            const fd = new FormData()
            fd.append('arquivoAtracoes', this.arquivo ? this.arquivo : '')
            const response = await programacaoService.importarAtracoesPlanilha(this.idProgramacao, fd)
            // console.log('ModalImportarItensLicitacao.enviarArquivo response', response)
            this.$toast.success(`Foram importadas ${response.length} atrações.`)
            this.$emit('fecharModal', true)
            this.arquivo = null
        } catch (e: any) {
            console.error('Falha ao importar atrações artísticas', e.response, e)
            this.tratarError(e)
        } finally {
            this.showLoading = false
        }
    }

}


</script>

<style scoped></style>